<template>
  <div class="basic-group-info mt-4">
    <p class="mt-2 mb-2">
      <span class="bold">Group Trainer:</span>
      {{ trainer_name }}
    </p>
    <b-form-group>
      <div v-if="loadingEditBool">
        <b-spinner></b-spinner>
      </div>
      <div v-if="editTrainerBool">
        <b-col>
          <b-form-group>
            <b-input-group>
              <b-form-input
                v-model="filteredResults"
                placeholder="Type to Search"
              />
              <b-input-group-append>
                <b-btn
                  :disabled="!filteredResults"
                  @click="filteredResults = ''"
                  >Clear</b-btn
                >
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-table
          v-cloak
          responsive
          :fields="searchResultsFields"
          :items="trainers"
          :striped="true"
          :bordered="true"
          :hover="true"
          stacked="md"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filteredResults"
          @filtered="onFiltered"
        >
          <template slot="cell(first_name)" slot-scope="row">
            <b-link
              @click.stop="stopClick"
              :to="{ name: 'EditTrainer', params: { id: row.item.uuid } }"
            >
              {{ row.item.first_name }} {{ row.item.middle_name }}
              {{ row.item.last_name }}
            </b-link>
            <br />
            <p class="small-date">country: {{ row.item.country }}</p>
            <p class="small-date">district: {{ row.item.region }}</p>
          </template>
          <template slot="cell(sex)" slot-scope="row">{{
            row.item.sex === "male" ? "M" : "F"
          }}</template>
          <template slot="cell(id)" slot-scope="row">
            <b-link class="add" @click.stop="setTrainer(row.item)">ADD</b-link>
          </template>
        </b-table>
        <b-row>
          <b-col md="6" class="my-1">
            <b-pagination
              :total-rows="trainers.length || 0"
              :per-page="perPage"
              v-model="currentPage"
              class="my-0"
            />
          </b-col>
        </b-row>
      </div>
      <div v-if="!editTrainerBool">
        <b-button @click.prevent="editTrainer">Edit</b-button>
      </div>
    </b-form-group>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "GroupTrainer",
  props: {
    parent: String,
  },
  data() {
    return {
      searchResultsFields: [
        { key: "first_name", label: "Name", sortable: true },
        { key: "sex", label: "Sex", sortable: true },
        { key: "id", label: "ADD" },
      ],
      currentPage: 1,
      perPage: 3,
      filteredResults: null,
      editTrainerBool: true,
      loadingEditBool: false,
    };
  },
  methods: {
    ...mapActions({
      GET_TRAINERS: "trainers/GET_TRAINERS",
      ADD_TRAINER: "groups/ADD_TRAINER",
      DELETE_TRAINER: "groups/DELETE_TRAINER",
    }),
    stopClick() {},
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async setTrainer(item) {
      console.log("current trainer: ", this.trainer_name);
      if (this.trainer_name_bool) {
        this.loadingEditBool = true;
        await this.DELETE_TRAINER({ id: this.group_trainer });
        this.loadingEditBool = false;
      }
      if (!this.add) {
        await this.ADD_TRAINER({ id: item.uuid });
      }

      this.$store.commit("groups/group_trainer", item.uuid);
      this.$store.commit(
        "groups/trainer_name",
        `${item.first_name} ${item.middle_name} ${item.last_name}`
      );
    },
    async editTrainer() {
      this.editTrainerBool = true;
    },
  },
  computed: {
    add() {
      return this.$route.path.includes("/add") ? true : false;
    },
    trainers: {
      get() {
        return this.$store.state.trainers.trainers;
      },
    },
    group_trainer: {
      get() {
        return this.$store.state.groups.group.group_trainer;
      },
    },
    trainer_name: {
      get() {
        return this.$store.state.groups.group.trainer_name;
      },
    },
    trainer_name_bool() {
      return this.trainer_name && this.trainer_name.length > 0;
    },
  },
  async mounted() {
    await this.GET_TRAINERS();
    console.log("mounting");
    if (this.trainer_name_bool) {
      this.editTrainerBool = false;
      console.log("mounting and setting false");
    }
  },
};
</script>

<style scoped>
.bold {
  font-weight: bold;
}
</style>
